enum FEATURE_FLAGS {
  ACCOUNT_CODES = 'account_codes_enabled',
  ADOPT_A_PET_OPT_IN = 'adopt_a_pet_opt_in',
  ADOPT_APP = 'adopt_app',
  BITE_REPORT_OUTSIDE_FIELD_SERVICES = 'bite_report_outside_field_services',
  CASH_DRAWER = 'cash_drawer',
  CLINIC_OUT_PAYMENTS = 'enable_clinic_out_payments',
  COMMUNITY_SUPPORT = 'community_support',
  EQUIPMENT_RENTAL = 'equipment_rental_enabled',
  FIELD_SERVICES = 'field_services',
  FIELD_SERVICES_DISPATCH = 'field_services_dispatch',
  FORMS_AND_APPLICATIONS = 'unlimited_forms',
  HILLS_REPORT = 'hills_report',
  KENNEL_MANAGER = 'use_kennel_manager',
  LOST_AND_FOUND = 'lost_found',
  PETCADEMY = 'petcademy',
  REHOME = 'rehome',
  SAVED_REPORTS = 'enable_saved_reports',
  SERVICE_OUT_PAYMENTS = 'enable_service_out_payments',
  SPDA_INTEGRATION = 'spda_integration_enabled',
  SURGERY_PRINT_FORMS = 'enable_surgery_print_forms',
  TNVR = 'tnvr',
  TRANSPORTS = 'transports',
  VCA_REPORT = 'vca_report',
  WEBSITES = 'enable_websites',
}

export { FEATURE_FLAGS };
